import React from 'react';
import SwipeableViews from 'react-swipeable-views';

class GalleryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryIndex: 0
    };
  }

  _handleGalleryIndex(index) {
    this.setState({
      galleryIndex: index
    });
  }

  render() {
    let images;
    let keyId = 0;
    images = this.props.images.map((image) => {
      keyId++;
      return <div key={keyId} className=''><img src={image} /></div>
    });

    let galleryHandler = this.props.images.map((elem, index) => {
      return <li key={index} onClick={this._handleGalleryIndex.bind(this, index)}><img src={elem} /></li>
    });

    return (
      <div className="image-gallery-container">
        <SwipeableViews children={images} index={this.state.galleryIndex}>
        </SwipeableViews>
        <ul className="gallery-handler">{galleryHandler}</ul>
      </div>
    );
  }
}

export default GalleryComponent;



// WEBPACK FOOTER //
// ./src/components/GalleryComponent.js